import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { type SelectOption } from '@td/core';
import type { CourtDetails, CourtsDetails } from './courts.type';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CourtsService {
  private readonly http = inject(HttpClient);

  loadList(): Observable<CourtsDetails> {
    return this.http.get<CourtsDetails>(`api/v1/lts/public/courts`);
  }

  loadCourt(id: string): Observable<CourtDetails> {
    return this.http.get<CourtDetails>(`api/v1/lts/public/courts/${id}`);
  }

  transform(data: CourtsDetails | null): Array<SelectOption> {
    if (!data) return [];

    const build = (_: TemplateStringsArray, ...values: Array<string | null>): string =>
      values.filter(Boolean).join(', ');

    return data.map((court) => {
      return {
        name: build`${court.name} ${court.address} ${court.address2} ${court.city} ${court.state} ${court.zipCode} ${court.phoneNumber}`,
        value: court.id,
      };
    });
  }
}
